import React, { createContext, useMemo, useState, useContext } from "react";
import {
  useQueryParam,
  StringParam,
  NumberParam,
  ArrayParam,
} from "use-query-params";

import filters from "utils/filters";

const SearcherContext = createContext();

function SearcherProvider({ children, values }) {
  const [sort = "popularForSorting", setSort] = useQueryParam(
    "sort",
    StringParam
  );
  const [page = 1, setPage] = useQueryParam("page", NumberParam);
  const [view] = useQueryParam("view", StringParam);
  const [priceMin, setPriceMin] = useQueryParam("priceMin", NumberParam);
  const [priceMax, setPriceMax] = useQueryParam("priceMax", NumberParam);
  const [category, setCategory] = useQueryParam("category", ArrayParam);
  const [investment, setInvestment] = useQueryParam("investment", ArrayParam);
  const [mainTitle, setMainTitle] = useQueryParam("mainTitle", StringParam);
  const [surfacemin, setSurfacemin] = useQueryParam("surfacemin", NumberParam);
  const [surfacemax, setSurfacemax] = useQueryParam("surfacemax", NumberParam);
  const [amenities, setAmenities] = useQueryParam("amenities", ArrayParam);
  const [contactLength, setContactLength] = useQueryParam(
    "contactLength",
    ArrayParam
  );
  const [vacationsDays, setVacationsDays] = useQueryParam(
    "vacationsDays",
    ArrayParam
  );
  const [backPercentage, setBackPercentage] = useQueryParam(
    "backPercentage",
    ArrayParam
  );

  const filterred_investments = filters({
    investments: values?.all_investments || [],
    page,
    sort,
    priceMin,
    priceMax,
    category,
    investment,
    mainTitle,
    surfacemin,
    surfacemax,
    amenities,
    contactLength,
    vacationsDays,
    backPercentage,
  });

  const state = {
    investments: filterred_investments,
    view,
    sort,
    priceMin,
    priceMax,
    category,
    investment,
    mainTitle,
    surfacemin,
    surfacemax,
    amenities,
    contactLength,
    vacationsDays,
    backPercentage,
    page,
  };

  const value = useMemo(() => {
    return {
      state,
      all_investments: values?.all_investments,
      setSort,
      setPriceMin,
      setPriceMax,
      setCategory,
      setInvestment,
      setMainTitle,
      setSurfacemin,
      setSurfacemax,
      setAmenities,
      setContactLength,
      setVacationsDays,
      setBackPercentage,
      setPage,
    };
  }, [state, values?.all_investments]);

  return (
    <SearcherContext.Provider value={value}>
      {children}
    </SearcherContext.Provider>
  );
}

const useSearcher = () => useContext(SearcherContext);
export { SearcherContext, useSearcher };
export default SearcherProvider;
